import { isFunction } from 'lodash';
import * as ComponentsDb from '@edit/tree/componentsdb.js';
import IconMapping from '@components/iconMapping.js';
export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    transform: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    disableIcon: {
      type: Boolean,
      required: true
    }
  },
  data() {
    const {type} = this.component;
    const dbentry = ComponentsDb.findDbEntry(this.component);
    if (typeof(dbentry) === 'undefined') {
      console.log('dbentry is null for', type);
    }
    const icon = IconMapping[type];
    const iconSize = ComponentsDb.iconSize;
    let dataSchema;
    if (isFunction(dbentry.condensedSchema)) {
      dataSchema = dbentry.condensedSchema({component});
    } else {
      dataSchema = dbentry.condensedSchema;
    }
    if (!dataSchema) {
      dataSchema = {
        fields: []
      }
    }
    return {
      dbentry,
      icon,
      iconSize,
      dataSchema
    }
  },
}
